module.exports = __webpack_public_path__ + "static/media/header-medium.555aa173.jpg";